export default "__VITE_ASSET__17af4a6e__"